<pre *ngIf="content" [innerHTML]="content"></pre>
